import Constants from './Constants';

export default class CustomerGenerator {
  constructor(seed) {
    this._defaultSeed = seed || Math.random();
  }

  /**
   * return [
   *    [{type: 'man', price: 333},...],
   *    [{},....],...
   * ]
   * @returns {*}
   */
  calcCustomers(ctx) {
    this.seed = this._defaultSeed;
    let totals = this.calcTotalsByWeatherAndPlace(ctx.weather, ctx.place);
    totals = this.calcTotalsByWeekdayAndPlace(totals, ctx.weekday, ctx.place);
    let totalCustomers = this.calcTotalCustomersByPlace(totals, ctx.place);
    let customers = this.calcCustomersByIceAndTemperature(totalCustomers, ctx.ice, ctx.temperature);
    return customers;
  }

  calcCustomersByIceAndTemperature(totalCustomers, ice, temperature) {
    return totalCustomers.map(total => {
      let customers = [];
      for (let i = 0; i < total.child; i++) {
        let price = Constants.MAX_PRICE * this.random();
        if (temperature < 20) {
          // do nothing
        } else if (temperature < 25) {
          price += 10;
        } else if (temperature < 30) {
          price += 30;
        } else {
          price += 50;
        }
        if (ice === Constants.ICE_VANILLA) {
          price = price + 20;
        }
        if (ice === Constants.ICE_BANANA) {
          price = price + 50;
        }
        if (price < Constants.MIN_PRICE) {
          price = Constants.MIN_PRICE;
        }
        customers.push({
          type: Constants.CUSTOMER_CHILD,
          price: price,
        });
      }

      for (let i = 0; i < total.man; i++) {
        let price = Constants.MAX_PRICE * this.random();
        if (temperature < 20) {
          // do nothing
        } else if (temperature < 25) {
          price += 10;
        } else if (temperature < 30) {
          price += 30;
        } else {
          price += 50;
        }
        if (ice === Constants.ICE_VANILLA) {
          price = price + 20;
        }
        if (ice === Constants.ICE_CHOCO) {
          price = price + 50;
        }
        if (price < Constants.MIN_PRICE) {
          price = Constants.MIN_PRICE;
        }
        customers.push({
          type: Constants.CUSTOMER_MAN,
          price: price,
        });
      }

      for (let i = 0; i < total.woman; i++) {
        let price = Constants.MAX_PRICE * this.random();
        if (temperature < 20) {
          // do nothing
        } else if (temperature < 25) {
          price += 10;
        } else if (temperature < 30) {
          price += 30;
        } else {
          price += 50;
        }
        if (ice === Constants.ICE_VANILLA) {
          price = price + 20;
        }
        if (ice === Constants.ICE_STRAWBERRY) {
          price = price + 50;
        }
        if (price < Constants.MIN_PRICE) {
          price = Constants.MIN_PRICE;
        }
        customers.push({
          type: Constants.CUSTOMER_WOMAN,
          price: price,
        });
      }

      return this.shuffle(customers);
    });
  }

  calcTotalCustomersByPlace(totals, place) {
    return totals.map(total => {
      let child = 0;
      let man = 0;
      let woman = 0;
      if (place === Constants.PLACE_ZOO) {
        child = total * 0.7;
        man = total * 0.1;
        woman = total * 0.2;
      } else if (place === Constants.PLACE_OFFICE_STREAT) {
        child = total * 0.1;
        man = total * 0.7;
        woman = total * 0.3;
      } else if (place === Constants.PLACE_SHOPPING_MALL) {
        child = total * 0.2;
        man = total * 0.2;
        woman = total * 0.6;
      }
      return { child: child, man: man, woman: woman };
    });
  }

  calcTotalsByWeatherAndPlace(weather, place) {
    let totals;
    if (place === Constants.PLACE_ZOO) {
      totals = Constants.ZOO_BASE_CUSTOMERS_NUM;
    } else if (place === Constants.PLACE_SHOPPING_MALL) {
      totals = Constants.SHOPPING_MALL_BASE_CUSTOMERS_NUM;
    } else {
      totals = Constants.OFFICE_BASE_CUSTOMERS_NUM;
    }

    return totals.map(total => {
      if (place === Constants.PLACE_ZOO) {
        if (weather === Constants.WEATHER_RAINY) {
          total = total * 0.9;
        } else if (weather === Constants.WEATHER_CLOUDY) {
          total = total * 1.1;
        } else if (weather === Constants.WEATHER_SUNNY) {
          total = total * 1.1;
        }
      } else if (place === Constants.PLACE_OFFICE_STREAT) {
        if (weather === Constants.WEATHER_RAINY) {
          total = total * 0.9;
        } else if (weather === Constants.WEATHER_CLOUDY) {
          total = total * 1.1;
        } else if (weather === Constants.WEATHER_SUNNY) {
          total = total * 1.1;
        }
      } else if (place === Constants.PLACE_SHOPPING_MALL) {
        if (weather === Constants.WEATHER_RAINY) {
          total = total * 1.3;
        } else if (weather === Constants.WEATHER_CLOUDY) {
          total = total * 1.1;
        } else if (weather === Constants.WEATHER_SUNNY) {
          total = total * 0.8;
        }
      }
      return total;
    });
  }

  calcTotalsByWeekdayAndPlace(totals, weekday, place) {
    return totals.map(total => {
      if (place === Constants.PLACE_ZOO) {
        if (weekday === weekday.WEEKDAY_SUNDAY || weekday === weekday.WEEKDAY_SATURDAY) {
          total *= 1.2;
        } else {
          total *= 0.8;
        }
      } else if (place === Constants.PLACE_OFFICE_STREAT) {
        if (weekday === weekday.WEEKDAY_SUNDAY || weekday === weekday.WEEKDAY_SATURDAY) {
          total *= 0.8;
        } else {
          total *= 1.2;
        }
      } else if (place === Constants.PLACE_SHOPPING_MALL) {
        if (weekday === weekday.WEEKDAY_SUNDAY || weekday === weekday.WEEKDAY_SATURDAY) {
          total *= 1;
        } else {
          total *= 1;
        }
      }
      return total;
    });
  }

  shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let r = Math.floor(this.random() * (i + 1));
      let tmp = array[i];
      array[i] = array[r];
      array[r] = tmp;
    }
    return array;
  }

  random() {
    let total = 0.0;
    for (let i = 0; i < 5; i++) {
      let x = Math.sin(this.seed) * 10000;
      this.seed = x - Math.floor(x);
      total += this.seed;
    }
    return total / 5.0;
  }
}
